(function(){
  var ROOT=(window.Shopify&&Shopify.routes&&Shopify.routes.root)||'/';
  function secId(){ var el=document.querySelector('[id^="shopify-section"][id*="cart-drawer"]'); return el?el.id.replace('shopify-section-',''):null; }
  function openDrawer(){ var t=document.querySelector('[aria-controls="CartDrawer"]'); if(t) t.click(); }
  function refreshDrawer(){
    var id=secId(); if(!id) return;
    fetch(ROOT+'?sections='+id).then(function(r){return r.json();}).then(function(data){
      var html=data[id]; if(!html) return;
      var tmp=document.createElement('div'); tmp.innerHTML=html;
      var fD=tmp.querySelector('#CartDrawer'), cD=document.getElementById('CartDrawer');
      if(fD&&cD) cD.innerHTML=fD.innerHTML;
      fetch(ROOT+'cart.js').then(function(r){return r.json();}).then(function(c){
        document.querySelectorAll('hdt-cart-count').forEach(function(el){ el.textContent=c.item_count; });
      });
    }).catch(function(){});
  }
  function addAndShow(form){
    var fd=new FormData(form);
    fetch(ROOT+'cart/add.js',{method:'POST',body:fd,headers:{'Accept':'application/json'}})
      .then(function(r){return r.json();})
      .then(function(){ openDrawer(); setTimeout(refreshDrawer,350); })
      .catch(function(){});
  }
  document.addEventListener('click',function(e){
    var b=e.target.closest('.ecom-product-single__add-to-cart--submit,.ecom-product-single__add-to-cart-buttons');
    if(!b) return;
    var form=b.closest('form[action*="/cart/add"]')||document.querySelector('form[action*="/cart/add"]');
    if(!form) return;
    e.preventDefault(); e.stopImmediatePropagation();
    addAndShow(form);
  }, true);
  document.addEventListener('submit',function(e){
    var form=e.target.closest && e.target.closest('form[action*="/cart/add"]');
    if(!form) return;
    e.preventDefault(); e.stopImmediatePropagation();
    addAndShow(form);
  }, true);
})();